import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial";
import { RootState } from "../../index";
import { getCoin } from "../../service/common";

export const coinSlice = createSlice({
  name: "coin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCoin.fulfilled, (state, { payload }) => {
        state.data = payload.data;
        state.loading = false;
      })
      .addCase(getCoin.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCoin.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default coinSlice.reducer;
export const SelectCoin = (state: RootState) => state.coin;
